import React, { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {isUndefined} from 'lodash';

import {restorePath} from 'ultra/helpers/route'
import {getShopDetails} from 'ultra/helpers/shop';
import {getClientCity} from 'ultra/configs/general'
import {DEFAULT_CITY} from 'ultra/const/general';
import {hasFullAccess} from 'ultra/helpers/auth';

import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';

import ShopingCart from '../ShopingCart'
import ContentImage from '../ContentImage';
import ShopCategoryLabel from '../ShopCategoryLabel';
// import ShopProductPrice from '../ShopProductPrice';
import Pagination from '../Pagination';

import PreloaderShop from '../../../../Components/Preloaders/PreloaderShop';

import Links from '../../Widgets/Links'
import FilterChip from '../../Widgets/FilterChip'
import NodeInlineActions from '../../Widgets/NodeInlineActions';

import {useSearchStore} from '../../../../Stores/search';
import {useConfigStore} from '../../../../Stores/config';

// import {filterContent} from '../../Helpers/content';

import {getFilter} from "../../../../Helpers/filters";
import {useGlobalCustomContext} from '../../../../Helpers/context';

import './index.scss'

function Products(props) {
    const {products, shop} = props;
    const {configs} = useConfigStore();
    const {userState} = useGlobalCustomContext();
    const [city] = useState(getClientCity(window) || DEFAULT_CITY);

    return Object.keys(products).map(product => {
            const item = products[product].data
            return <Grid item xs={6} md={3} key={item._uri}>
                <div className={`productWrap ${item._published ? '' : 'published'} ${item.available ? '' : 'productNotAvailable'}`}>
                    <RouterLink to={restorePath(item._uri)}>
                        <div className='photoWrap'>
                            <ContentImage src="thumbnail" image={item.thumbnail} className="photo" />
                            
                            {!item.available && <div className="photoLabel">
                                <Chip label="Тимчасово недоступний" />
                            </div>}

                            {item.available && item.status && <div className="photoLabel">
                                <FilterChip value={item.status} config={configs.content.nodes['shop-product'].fields.status} />
                            </div>}
                        </div>
                    </RouterLink>
                    
                    <NodeInlineActions direction="up" permits={products[product].permits} node={item} city={city} hasFullAccess={hasFullAccess(userState.user)} />

                    <div className="productTitle">
                        {!item._published && <small>Не опубліковано</small>}
                        {item.title}
                    </div>

                    <div className="button">
                        <ShopingCart
                            fullWidth
                            price={item.price}
                            item={item}
                            shop={shop}
                        />
                    </div>

                    {/* <div className="price">
                        <ShopProductPrice product={item} currency={shop.partner_config.currency} />
                    </div> */}
                </div>
            </Grid>
        })
}

export default function ShopProductsList(props) {
    const {items, breadcrumbs, content, showPagination, showSkeleton} = props // searchBy
    // permits

    const {configs} = useConfigStore();
    const {search} = useSearchStore();

    const [city] = useState(getClientCity(window) || DEFAULT_CITY);

    const [shop, setShop] = useState()
    const [categoriesSettings, setCategoriesSettings] = useState()
    
    const [noCategorisedLinks, setNoCategorisedLinks] = useState()
    const [categories, setCategories] = useState()
    const [byCategories, setByCategories] = useState()

    // function getFilteredList() {
    //     let list = items?.list;
    //     if (items?.list && search && searchBy) {
    //         list = filterContent(configs.content.nodes, items?.list, searchBy, search)
    //     }
    //     return list;
    // }

    useEffect(() => {
        const shopData = getShopDetails(content, breadcrumbs)?.shop;

        if (items) {
            // let list = getFilteredList();
            const {list, permits, order} = items;

            // shop has categories config
            if (shopData?.categories && shopData?.categories?.source) {
                const config = getFilter(configs.filters, city, shopData.categories.source);

                const noCategoriesItems = {}
                const sortedProducts = {}
                const categoriesOrder = config.order || Object.keys(config.values).sort()

                categoriesOrder?.map(category => {
                    order.map(item => {
                        const product = list[item];
                        if (product?.category === category) {
                            sortedProducts[category] = sortedProducts[category] || []
                            sortedProducts[category].push({
                                permits: permits[item],
                                data: product
                            })
                        }
                    })
                });

                order.map(item => {
                    if (!categoriesOrder?.includes(list[item]?.category)) {
                        noCategoriesItems[item] = list[item]
                    }
                })

                setCategoriesSettings(config);
                setByCategories(sortedProducts)
                setCategories(categoriesOrder);
                setNoCategorisedLinks({
                    list: noCategoriesItems,
                    order: Object.keys(noCategoriesItems).sort()
                });
            }
            // no categories shop config
            else {
                const categories = []

                if (items) {
                    Object.keys(list).find(i => {
                        const {category} = list[i];

                        if (!isUndefined(category) && !categories.includes(category)) {
                            categories.push(category);
                        }
                    });
                }

                setCategories(categories);
            }

            setShop(shopData);
        }
    }, [items, search])

    if (showSkeleton || !shop) return <PreloaderShop />

    if (shop?.categories) {
        if (!categories || categories.length === 0) return <></>

        return <div className="ShopProductsList">
            {categories.map(category => <React.Fragment key={category}>
                {byCategories[category] &&
                    <ShopCategoryLabel category={category} categories={categoriesSettings} />
                }

                {byCategories[category] && <Grid container spacing={4}>
                    <Products shop={shop} products={byCategories[category]} />
                </Grid>
                }
            </React.Fragment>)}
        </div>
    }

    // NO CATEGORIES
    const sortedProducts = []
    items.order.map(link => {
        // let list = getFilteredList();
        const {list, permits} = items;

        if (list[link]?._type !== 'shop-product' && list[link]?._type !== 'shop-alias') return;
        sortedProducts.push({
            permits: permits[link],
            data: {...list[link]}
        });
    })

    if (sortedProducts.length === 0) return <></>

    return <div className="ShopProductsList">
        <Grid container spacing={4}>
            <Products shop={shop} products={sortedProducts} />

            {showPagination && <Grid item xs={12}>
                <Pagination pagination={items.pagination} />
            </Grid>}

            <Links links={noCategorisedLinks}/>
        </Grid>
    </div>
}
